var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "travel-block",
      class: { "travel-block--open": _vm.showTravelInfo },
      on: { click: _vm.toogleFlightSchedule }
    },
    [
      _c("div", { staticClass: "travel-block__header" }, [
        _c("span", {
          staticClass: "travel-block__header__title",
          domProps: { textContent: _vm._s(_vm.title) }
        }),
        _vm._v(" "),
        _vm.formattedDate
          ? _c("span", {
              staticClass: "travel-block__header__date",
              domProps: { textContent: _vm._s(_vm.formattedDate) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "travel-block__header__arrow",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 395.65 223"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "travel-block__body" },
        [
          _c("div", { staticClass: "time-city" }, [
            _vm.startTime
              ? _c("h3", { domProps: { textContent: _vm._s(_vm.startTime) } })
              : _vm._e(),
            _vm._v(" "),
            _vm.startCity
              ? _c("span", { domProps: { textContent: _vm._s(_vm.startCity) } })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "time-stop" }, [
            _vm.totalTime
              ? _c("span", {
                  staticClass: "time-stop__travel-length",
                  domProps: { textContent: _vm._s(_vm.totalTime) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.totalStops
              ? _c("span", {
                  staticClass: "time-stop__stops",
                  domProps: { textContent: _vm._s(_vm.totalStops) }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "time-city" }, [
            _vm.endTime
              ? _c("h3", { domProps: { textContent: _vm._s(_vm.endTime) } })
              : _vm._e(),
            _vm._v(" "),
            _vm.endCity
              ? _c("span", { domProps: { textContent: _vm._s(_vm.endCity) } })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "flight-transition" } }, [
            _vm.showTravelInfo
              ? _c("div", { staticClass: "flight-view" }, [
                  _c("div", { staticClass: "flight-view__content" }, [
                    _c(
                      "div",
                      { staticClass: "flight-details" },
                      [
                        _vm._l(_vm.legList, function(leg, legKey) {
                          return _c(
                            "div",
                            {
                              key: legKey,
                              staticClass: "flight-details__item"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flight-details__departure" },
                                [
                                  _c("p", {
                                    staticClass: "flight-details__time",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.formatTime(leg.departureDateTime)
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    domProps: {
                                      textContent: _vm._s(
                                        leg.departureAirport.name
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flight-details__plane" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flight-details__plane__icon"
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("./../../img/icons/icon-plane-down.svg")
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "flight-details__plane__text"
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            leg.flightCarrier.name
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(leg.flightNumber)
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flight-details__arrival" },
                                [
                                  _c("p", {
                                    staticClass: "flight-details__time",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.formatTime(leg.arrivalDateTime)
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    domProps: {
                                      textContent: _vm._s(
                                        leg.arrivalAirport.name
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.airportTimes, function(airportTime) {
                          return _c(
                            "div",
                            {
                              key: airportTime.airport.code,
                              staticClass: "flight-details__stop"
                            },
                            [
                              _c("p", {
                                staticClass: "flight-details__stop__airport",
                                domProps: {
                                  textContent: _vm._s(airportTime.airport.name)
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "flight-details__stop__time" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.translations.time_in_airport) +
                                      " " +
                                      _vm._s(airportTime.time)
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flight-details__stop flight-details__stop--total"
                          },
                          [
                            _c("p", {
                              staticClass: "flight-details__stop__airport",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.translations.total_travel_time
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "flight-details__stop__time",
                              domProps: { textContent: _vm._s(_vm.totalTime) }
                            })
                          ]
                        )
                      ],
                      2
                    )
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1435669e", { render: render, staticRenderFns: staticRenderFns })
  }
}